module.exports = {
	"dk": {
		"EmbedPlayer": {
			"url": "/embed/:postId",
			"component": "VideoEmbed/EmbedPage"
		},
		"EmbedPlayerPartner": {
			"url": "/embed/:partnerId/:postId",
			"component": "VideoEmbed/EmbedPage"
		},
		"PlayerInfoWidget": {
			"url": "/sport/:sports/info/spillere/:id",
			"component": "WidgetPages/WidgetIndex",
			"props": {
				"widgetType": "player_info"
			}
		},
		"TeamInfoWidget": {
			"url": "/sport/:sports/info/hold/:id",
			"component": "WidgetPages/WidgetIndex",
			"props": {
				"widgetType": "squad_stats"
			}
		},
		"SportNewsRedirect": {
			"url": "/sport/:sports",
			"props": {
				"redirectPath": "nyheder"
			}
		},
		"SportsArticleFeedPage": {
			"url": "/sport/:sports/nyheder",
			"component": "NewsFeed/NewsFeedPage"
		},
		"ArticlePage": {
			"url": "/sport/:sports/nyheder/:slug",
			"component": "ArticleFeed/ArticlePage"
		},
		"LeaguePage": {
			"url": "/sport/:sports/liga/:competitions",
			"component": "NewsFeed/NewsFeedPage"
		},
		"VideoType": {
			"url": "/sport/:sports/tags/:videoTypes",
			"component": "NewsFeed/NewsFeedPage"
		},
		"TeamListPage": {
			"url": "/sport/:sports/hold",
			"component": "Teams/TeamList"
		},
		"TeamPage": {
			"url": "/sport/:sports/hold/:teams",
			"component": "NewsFeed/NewsFeedPage"
		},
		"PodcastPage": {
			"url": "/sport/:sports/podcasts/:podcasts/",
			"component": "ArticleFeed/ArticlePage"
		},
		"PodcastPageWithSlug": {
			"url": "/sport/:sports/podcasts/:podcasts/:slug",
			"component": "ArticleFeed/ArticlePage"
		},
		"BlogListPage": {
			"url": "/sport/:sports/blog",
			"component": "MediaPages/BlogList"
		},
		"BlogPage": {
			"url": "/sport/:sports/blog/:blogs/",
			"component": "ArticleFeed/ArticlePage"
		},
		"BlogPageWithSlug": {
			"url": "/sport/:sports/blog/:blogs/:slug",
			"component": "ArticleFeed/ArticlePage"
		},
		"Live": {
			"url": "/live",
			"component": "Sidebar/LiveArea"
		},
		"VideoPage": {
			"url": "/sport/:sports/video",
			"component": "Video/VideoPage"
		},
		"VideoPageAllSports": {
			"url": "/video",
			"component": "Video/VideoPage"
		},
		"MobileSportsArticleFeedPage": {
			"url": "/sport/motorsport/nyheder",
			"component": "NewsFeed/NewsFeedPage"
		},
		"MobileVideoPageAllSports": {
			"url": "/mobilevideo",
			"component": "Video/MobileVideoPage"
		},
		"EventsPage": {
			"url": "/sport/:sports/video/:events",
			"component": "ArticleFeed/ArticlePage"
		},
		"EventsPageAllSports": {
			"url": "/video/:events",
			"component": "ArticleFeed/ArticlePage"
		},
		"Login": {
			"url": "/login",
			"component": "Account/Login"
		},
		"Search": {
			"url": "/sog",
			"component": "Search/SearchPage"
		},
		"LeagueIndexPage": {
			"url": "/sport/:sports/liga",
			"component": "Leagues/LeagueList"
		},
		"TablesPageFodbold": {
			"url": "/sport/fodbold/tabeller",
			"component": "WidgetPages/TablesFodbold"
		},
		"TablesPageNfl": {
			"url": "/sport/nfl/tabeller",
			"component": "WidgetPages/TablesNfl"
		},
		"TablesPageHandbold": {
			"url": "/sport/handbold/tabeller",
			"component": "WidgetPages/TablesHandbold"
		},
		"TablesPageIshockey": {
			"url": "/sport/ishockey/tabeller",
			"component": "WidgetPages/TablesIshockey"
		},
		"LiveScorePageFodbold": {
			"url": "/sport/fodbold/livescore",
			"component": "WidgetPages/LiveScoreFodbold"
		},
		"LiveScorePageIshockey": {
			"url": "/sport/ishockey/livescore",
			"component": "WidgetPages/LiveScoreIshockey"
		},
		"LiveScorePageTennis": {
			"url": "/sport/tennis/livescore",
			"component": "WidgetPages/LiveScoreTennis"
		},
		"TvGuide": {
			"url": "/tv-guide",
			"component": "TvGuide/TvGuide"
		},
		"LongformLanding": {
			"url": "/premium",
			"component": "Longform/LongformLanding"
		},
		"Longform": {
			"url": "/premium/:programType",
			"component": "Longform/Longform"
		},
		"LongformWithSlug": {
			"url": "/premium/:programType/:slug",
			"component": "Longform/Longform"
		},
		"XLBYG": {
			"url": "/xl-byg",
			"component": "XLBYG/XLBYG"
		},
		"eksperttest": {
			"url": "/eksperttest",
			"component": "QUIZ/QUIZ"
		},
		"EURO2020": {
			"url": "/em2020",
			"component": "NewsFeed/Euro2020NewsFeedPage"
		},
		"VM2023": {
			"url": "/vm",
			"component": "NewsFeed/VMNewsFeedPage"
		},
		"quiz": {
			"url": "/quiz",
			"component": "QUIZFB/QUIZFB"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/translatedRoutes.json
// module id = 404
// module chunks = 6